import { Reveal, SectionHead, Wrap } from "./Motion";

const Edition = ({ a, i }) => (
  <article className={`group relative h-full flex flex-col overflow-hidden border card-hover ${a.highlight ? "border-[#D4AF37]/60 bg-[#142447] shadow-[0_0_60px_-20px_rgba(212,175,55,0.35)]" : "border-white/10 bg-[#0F1D3D]"}`} data-testid={`archive-edition-${a.year}`}>
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={a.image} alt={`Ballypatrick Auctions ${a.year}`} className="h-full w-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1630] via-[#0B1630]/30 to-transparent" />
      <span className="absolute -bottom-3 left-4 font-display text-[5.5rem] lg:text-[7rem] leading-none text-[#D4AF37] drop-shadow-[0_6px_24px_rgba(0,0,0,0.6)]">{a.edition}</span>
      <span className="absolute top-4 right-4 font-mono text-[11px] tracking-[0.2em] text-[#F8F6F0]/85 bg-[#0B1630]/60 backdrop-blur px-2.5 py-1 border border-white/10">{a.year}</span>
      {a.highlight && <span className="absolute top-4 left-4 bg-[#D4AF37] text-[#0B1630] px-2.5 py-1 text-[9px] font-mono uppercase tracking-[0.2em]">Record edition</span>}
    </div>
    <div className="p-5 lg:p-6 flex-1 flex flex-col">
      <p className="text-[9px] tracking-[0.22em] uppercase text-[#6F7C97]">Turnover · {a.lots} lots</p>
      <p className="mt-1 font-display text-3xl lg:text-4xl text-[#F8F6F0]">{a.turnover}</p>
      <div className="mt-4 pt-4 border-t border-white/8">
        <p className="text-sm text-[#D4AF37]">{a.topper}</p>
        <p className="mt-1 text-xs text-[#AEB7C9] leading-relaxed">{a.note}</p>
      </div>
    </div>
  </article>
);

export const Archive = ({ archive = [] }) => (
  <section id="archive" className="relative py-20 lg:py-32 navy-glow" data-testid="archive-section">
    <Wrap>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHead eyebrow="The Archive · Four editions" id="archive" title="A record that compounds every December." sub="From a 21-lot debut to Ireland's record online sale — and Auction V is next." />
        <Reveal delay={0.15}>
          <div className="flex gap-8 lg:gap-12">
            {[["€13.5M", "Four-year turnover"], ["109", "Lots sold"], ["37+", "Countries"]].map(([v, l]) => (
              <div key={l}><p className="font-display text-3xl lg:text-4xl text-[#D4AF37]">{v}</p><p className="text-[10px] tracking-[0.18em] uppercase text-[#6F7C97]">{l}</p></div>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="mt-10 snap-row lg:hidden -mx-5 px-5" data-testid="archive-snap-row">
        {archive.map((a, i) => <div key={a.year} className="w-[74vw] max-w-[320px]"><Edition a={a} i={i} /></div>)}
      </div>
      <div className="hidden lg:grid grid-cols-4 gap-6 mt-14" data-testid="archive-grid">
        {archive.map((a, i) => <Reveal key={a.year} delay={i * 0.1} className="h-full"><Edition a={a} i={i} /></Reveal>)}
      </div>
    </Wrap>
  </section>
);
